import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import {
  TerritoryFeature,
  TerritoryMapObject,
} from '../../../map/features/territories/territory-feature';

/**
 * The territory layer's control panel: the roster of what is drawn, and a way
 * back to the page that owns it.
 *
 * The panel reads the same lightweight map data the layer draws. The routed
 * Territories page may add analytics to those rows, but the roster and the
 * polygons share one source of boundary identity.
 */
@Component({
  selector: 'app-territory-control',
  templateUrl: './territory-control.component.html',
  styleUrls: ['./territory-control.component.css'],
})
export class TerritoryControlComponent implements OnInit, OnDestroy {
  private selectedObjectIds = new Set<number>();
  private readonly subs = new Subscription();

  constructor(
    private feature: TerritoryFeature,
  ) {}

  ngOnInit(): void {
    this.subs.add(this.feature.selection.changed$.subscribe(() => {
      this.selectedObjectIds = new Set(this.feature.selection.ids);
    }));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  get rows(): TerritoryMapObject[] {
    return this.feature.objects;
  }

  get layerHidden(): boolean {
    return !this.feature.enabled;
  }

  /** Selecting from the panel does what selecting on the map does, and frames
   *  the boundary — the roster is a list of places, not just of names. */
  pick(row: TerritoryMapObject): void {
    this.feature.selection.replace([row.id]);
    this.feature.zoomTo(row);
  }

  isSelected(row: TerritoryMapObject): boolean {
    return this.selectedObjectIds.has(row.id);
  }

  colorOf(row: TerritoryMapObject): string {
    return row.color || '#607d8b';
  }

  leadCount(row: TerritoryMapObject): number | null {
    return this.feature.metricsFor(row.id)?.leads ?? null;
  }

}
